import { Component, Input } from '@angular/core';
import { getDroplinkValue } from '@core/jss-utils';
import { ReviewStatistics } from '@integration/reviews-api-models';

import {
  ReviewsComponentRendering,
  ReviewScoreWidgetType,
} from '../reviews.model';

@Component({
  selector: 'wl-review-score[stats][rendering]',
  templateUrl: './review-score.component.html',
  styleUrls: [
    './review-score.component.ed.scss',
    './review-score.component.essent.scss',
  ],
})
export class ReviewScoreComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: ReviewsComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stats!: ReviewStatistics;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() type: ReviewScoreWidgetType = 'small';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showCard = true;

  get fields() {
    return this.rendering.fields;
  }

  get buttonStyle() {
    return getDroplinkValue(this.fields, 'ButtonStyle');
  }
}
